import { loadFilters } from './filtersSlice';
import { loadPrefs } from './prefsSlice';
import { loadChartsHidden, loadNavExpanded } from './uiSlice';
import { loadViews } from './viewsSlice';

/** Persisted portal state (filters, preferences, menu, hidden charts, saved views): the preloaded state. */
export function loadPortalState() {
  const prefs = loadPrefs();
  return {
    prefs,
    filters: loadFilters(prefs.unit),
    ui: {
      accountDrawerId: null,
      navExpanded: loadNavExpanded(),
      chartsHidden: loadChartsHidden(),
      toasts: [],
    },
    views: loadViews(),
  };
}
